/**
 * Copyright © 2025 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import React, { useState } from "react";
import PropTypes from "prop-types";

import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  TextField,
  IconButton,
  LinearProgress,
} from "@mui/material";
import { Close as CloseIcon } from "@mui/icons-material";
import { CloudUpload as FolderIcon } from "@mui/icons-material";
import styled from "@emotion/styled";
import { Typography } from "antd";

const FileUploadDialog = ({ loading, setLoading, open, onClose, onUpload }) => {
  const [file, setFile] = useState(null);

  const handleFileChange = (event) => {
    setFile(event.target.files[0]);
  };

  const handleUpload = async () => {
    setLoading(true);
    await onUpload(file);
  };

  const FileLoader = styled(Button)`
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    position: relative;
    height: 250px;
    width: 100%;
    background: rgba(245, 245, 245, 0.5);
    border: 1px dashed rgba(112, 112, 112, 0.5);
    border-radius: 3px;
    & input {
      width: 100%;
      height: 100%;
      cursor: pointer;
    }
  `;

  return (
    <Dialog
      PaperProps={{ style: { overflowX: "hidden" } }}
      open={open}
      onClose={onClose}
    >
      <DialogTitle
        style={{ paddingLeft: "400px", alignSelf: "center", width: 500 }}
      >
        Upload File
        <IconButton
          edge="end"
          color="inherit"
          onClick={onClose}
          aria-label="close"
          sx={{ position: "absolute", right: 8, top: 8 }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ height: 300, alignContent: "center" }}>
        <input
          accept="*"
          style={{ display: "none" }}
          id="raised-button-file"
          type="file"
          onChange={handleFileChange}
        />
        <label style={{ marginTop: "400px" }} htmlFor="raised-button-file">
          <FileLoader component="span">
            <FolderIcon sx={{ color: "black", fontSize: 100 }} />
            <Typography>
              Drag and drop a file here, or click to select
            </Typography>
            {file && (
              <TextField fullWidth margin="normal" value={file.name} disabled />
            )}
          </FileLoader>
          {loading && <LinearProgress sx={{ marginTop: "16px" }} />}
        </label>
      </DialogContent>
      <DialogActions sx={{ paddingRight: "200px" }}>
        <Button
          variant="contained"
          onClick={onClose}
          sx={{
            backgroundColor: "grey",
            color: "white",
            paddingX: "20px",
            paddingY: "10px",
            borderRadius: "22px",
            transition: "background-color 0.3s ease",
            fontWeight: 600,
          }}
          disabled={loading}
        >
          Cancel
        </Button>
        <Button
          onClick={handleUpload}
          color="dark"
          variant="contained"
          disabled={loading}
          sx={{
            paddingX: "20px",
            paddingY: "10px",
            borderRadius: "22px",
            transition: "background-color 0.3s ease",
            fontWeight: 600,
          }}
        >
          Upload
        </Button>
      </DialogActions>
    </Dialog>
  );
};

FileUploadDialog.propTypes = {
  loading: PropTypes.string,
  setLoading: PropTypes.func,
  open: PropTypes.string,
  onClose: PropTypes.func,
  onUpload: PropTypes.func,
};
export default FileUploadDialog;
